module.exports = __webpack_public_path__ + "img/131.4.bdd14ef4.png";